import { render } from "./UploadZone.vue?vue&type=template&id=5de46d8c&scoped=true"
import script from "./UploadZone.vue?vue&type=script&lang=js"
export * from "./UploadZone.vue?vue&type=script&lang=js"

import "./UploadZone.vue?vue&type=style&index=0&id=5de46d8c&scoped=true&lang=css"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de46d8c"]])

export default __exports__